@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/spacing.module.less';

@shipment-status-label-border-radius: 2px;

.status-label-mixin(@primaryColor; @secondaryColor; @iconPadding: 0px) {
  &:extend(.shipment-status-label);

  .pill {
    display: inline-flex;
    align-content: center;
    background: @primaryColor;
    border-color: @primaryColor;
  }

  .status-text {
    background: @secondaryColor;
  }

  .status-icon {
    fill: @primaryColor;
    padding: @iconPadding;
  }
}

.status-label-wrapper {
  display: inline-flex;
  align-content: center;
  background-color: @shipment-status-label--background-color;
  border-radius: @shipment-status-label-border-radius;
  height: 20px;

  & > * {
    display: flex;
    align-items: center;
    padding: 0 @space-8;
    border-top: 1px solid @shipment-status-label--border-color;
    border-bottom: 1px solid @shipment-status-label--border-color;

    &:first-child {
      border-left: 1px solid @shipment-status-label--border-color;
      border-top-left-radius: @shipment-status-label-border-radius;
      border-bottom-left-radius: @shipment-status-label-border-radius;
    }

    &:last-child {
      border-right: 1px solid @shipment-status-label--border-color;
      border-top-right-radius: @shipment-status-label-border-radius;
      border-bottom-right-radius: @shipment-status-label-border-radius;
    }
  }
}

.shipment-status-label {
  display: inline-block;
  margin-right: @shipment-status-label-border-radius;
  font-size: 12px;
}

.dual-status-container {
  display: inline-flex;
  align-items: center;
  gap: @space-8;
}

.tracking-status {
  padding: 0;
}

.pill {
  width: 8px;
  padding: 0;
}

.status-text {
  border-right: 1px solid @shipment-status-label--border-color;
  font-weight: @normal;
  white-space: nowrap;
}

.refund-status-text {
  border-right: 1px solid @shipment-status-label--border-color;
  font-weight: @normal;
  white-space: nowrap;
  background: @shipment-status-label--shipped--background-color;
}

.status-icon {
  height: 12px;
  width: 12px;
  margin: 0 4px 0 -4px;
}

.button {
  color: @shipment-status-label--button--text-color;
  font-size: 12px;
  border-left: none;
  border-right: none;
  background: transparent;
  cursor: pointer;
  padding-left: 0;

  &:hover {
    color: @shipment-status-label--button--hover--text-color;
  }
}

.unshipped {
  .status-label-mixin(
    @shipment-status-label--unshipped--left-border-color,
    @shipment-status-label--unshipped--background-color
  );
}

.shipped {
  .status-label-mixin(
    @shipment-status-label--shipped--left-border-color,
    @shipment-status-label--shipped--background-color,
    2px
  );
}

.cancelled {
  .status-label-mixin(
    @shipment-status-label--cancelled--left-border-color,
    @shipment-status-label--cancelled--background-color
  );
}

.awaitingpayment {
  .status-label-mixin(
    @shipment-status-label--awaiting-payment--left-border-color,
    @shipment-status-label--awaiting-payment--background-color
  );
}

.onhold {
  .status-label-mixin(
    @shipment-status-label--on-hold--left-border-color,
    @shipment-status-label--on-hold--background-color
  );
}

.outstanding {
  .status-label-mixin(
    @shipment-status-label--outstanding--left-border-color,
    @shipment-status-label--outstanding--background-color,
    2px
  );
}

.returned {
  .status-label-mixin(
    @shipment-status-label--returned--left-border-color,
    @shipment-status-label--returned--background-color,
    2px
  );
}

.received {
  .status-label-mixin(
    @shipment-status-label--received--left-border-color,
    @shipment-status-label--received--background-color,
    2px
  );
}

.allocated {
  .status-label-mixin(
    @shipment-status-label--allocated--left-border-color,
    @shipment-status-label--allocated--background-color,
    1px
  );
}

.reshipped {
  .status-label-mixin(
    @shipment-status-label--reshipped--left-border-color,
    @shipment-status-label--reshipped--background-color,
    2px
  );
}

.pendingfulfillment {
  .status-label-mixin(
    @shipment-status-label--pending-fulfillment--left-border-color,
    @shipment-status-label--pending-fulfillment--background-color
  );
}

.rejectedfulfillment {
  .status-label-mixin(
    @shipment-status-label--rejected-fulfillment--left-border-color,
    @shipment-status-label--rejected-fulfillment--background-color
  );
}

// refund assist statuses
.refundeligible {
  .status-label-mixin(
    @shipment-status-label--unshipped--left-border-color,
    @shipment-status-label--unshipped--background-color
  );
}
.refundscheduled {
  .status-label-mixin(
    @shipment-status-label--unshipped--left-border-color,
    @shipment-status-label--unshipped--background-color
  );
}

.refundpending {
  .status-label-mixin(
    @shipment-status-label--unshipped--left-border-color,
    @shipment-status-label--unshipped--background-color
  );
}

.refunded {
  .status-label-mixin(
    @shipment-status-label--shipped--left-border-color,
    @shipment-status-label--shipped--background-color
  );
}

.refundcanceled {
  .status-label-mixin(
    @shipment-status-label--cancelled--left-border-color,
    @shipment-status-label--cancelled--background-color
  );
}

.refundrejected {
  .status-label-mixin(
    @shipment-status-label--outstanding--left-border-color,
    @shipment-status-label--outstanding--background-color
  );
}

.refunddisabled {
  .status-label-mixin(
    @shipment-status-label--cancelled--left-border-color,
    @shipment-status-label--cancelled--background-color
  );
}
